export const GAME_TITLE = "Sports Connections";
export const MAX_MISTAKES = 4;
export const SUPPORTED_SPORTS = ["nfl", "nba", "mlb"];
export const DEFAULT_SPORT = "nfl";
export const SPORT_LABELS = {
    nfl: "NFL",
    nba: "NBA",
    mlb: "MLB",
};
